import {Component, OnInit} from '@angular/core';
import {KYCProfile, KYCStatusResult} from "../../api/entity/kyc-verification";
import {KycService} from "../../api/service/kyc.service";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";
import {AmlPepDetails, CustomerProfile, CustomerProfileService, FileDownloadService} from "../../api";
import {Response} from "@angular/http";
import {FileUtils} from "../../../../../../../common/utils";
import {InjectOptionDialog, OptionDialog} from "../../../../../shared/option-dialog";
import {isEmpty} from "lodash";

@Component({
    selector: 'tfl-bo-kyc-verification',
    template: `
        <loading-linear [loading]="loading"></loading-linear>
        <h3>
            <!--            <button (click)="onClickButton()"-->
            <!--                    [disabled]="profileStatusResult == kycStatusResult.IN_PROGRESS || loading"-->
            <!--                    class="btn verify-btn-box pull-right btn-primary"-->
            <!--                    [ngClass]="{'btn-primary': !isUpdateButton(),-->
            <!--                            'btn-success': isUpdateButton()}">-->
            <!--                <ng-container-->
            <!--                    *ngIf="!isUpdateButton()">{{ 'CUSTOMER.VERIFICATION.VERIFY_BUTTON' | translate }}-->
            <!--                </ng-container>-->
            <!--                <ng-container-->
            <!--                    *ngIf="isUpdateButton()">{{ 'CUSTOMER.VERIFICATION.UPDATE_BUTTON' | translate }}-->
            <!--                </ng-container>-->
            <!--            </button>-->


            <!--            <button (click)="downloadCRAFile()"-->
            <!--                    class="btn verify-btn-box pull-right btn-primary">-->

            <!--                <ng-container>{{ 'CUSTOMER.VERIFICATION.KYC.CAR' | translate }}-->
            <!--                </ng-container>-->
            <!--            </button>-->

            <button (click)="downloadReport()"
                    class="btn verify-btn-box pull-right btn-primary">

                <ng-container>REPORT
                </ng-container>
            </button>

            <!--            <div *ngIf="profileStatus === 'M' || profileStatus === 'O'">-->
            <!--                <button (click)="kycApproved()"-->
            <!--                        [disabled]="checkCRA()"-->
            <!--                        class="btn verify-btn-box pull-right btn-primary">-->

            <!--                    <ng-container>KYC Approved-->
            <!--                    </ng-container>-->
            <!--                </button>-->
            <!--            </div>-->

            {{ 'CUSTOMER.VERIFICATION.KYC.TITLE' | translate }}

            <tfl-bo-kyc-status-badge
                    explanation="{{ 'CUSTOMER.VERIFICATION.KYC.OVERALL' | translate }}"
                    [status]="profileStatusResult"
                    class="pull-right">
            </tfl-bo-kyc-status-badge>
        </h3>

        <hr/>

        <div class="row" *ngIf="hasAmlErrors()">
            {{ 'CUSTOMER.VERIFICATION.AML.TITLE' | translate }}
            <div *ngIf="amlReasons">
                {{ 'CUSTOMER.VERIFICATION.AML.AML_REASON_FIELDS' | translate }}
                <ul id="reasons" style="list-style-type: disc">
                    <li *ngFor="let reason of amlReasons">
                        {{ reason }}
                    </li>
                </ul>
            </div>
            <div>
                <div *ngIf="isPrivate() && amlPepDetails">
                    {{ 'CUSTOMER.VERIFICATION.AML.AML_DETAILS_PEP' | translate }}
                    <ul id="details" style="list-style-type: circle">
                        <li *ngFor="let details of amlPepDetails[0]?.amlPepDetailsList">
                            {{ details }} <br>
                        </li>
                    </ul>
                </div>
                <ul id="pepDetails" style="list-style-type: circle" *ngIf="!isPrivate() && amlPepDetails">
                    <li *ngFor="let pep of amlPepDetails">
                        {{ pep.name }} <br>
                        {{ pep.type }} <br>
                        <ul id="details" style="list-style-type: square">
                            <li *ngFor="let details of pep.amlPepDetailsList">
                                {{ details }} <br>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

        <div *ngIf="isAOBVerified()" class="row">
            <div class="col-xs-12">
                <h3 class="text-center">
                    {{ AOBStatus }}
                </h3>
            </div>
        </div>
        <div *ngIf="isNotVerified()" class="row">
            <div class="col-xs-12">
                <h3 class="text-center">
                    {{ 'CUSTOMER.VERIFICATION.KYC.EMPTY_PROFILE' | translate }}
                </h3>
            </div>
        </div>
        <tfl-bo-kyc-results-corporate
                *ngIf="kycProfile?.corporate_profile"
                [results]="kycProfile.corporate_profile"
                [summaryStatus]="kycProfile.summary_status">
        </tfl-bo-kyc-results-corporate>
        <tfl-bo-kyc-results-private
                *ngIf="kycProfile?.private_profile"
                [results]="kycProfile.private_profile"
                [summaryStatus]="kycProfile.summary_status">
        </tfl-bo-kyc-results-private>
    `
})
export class KYCVerificationComponent implements OnInit {

    kycProfile: KYCProfile;
    loading = false;
    profileStatusResult: KYCStatusResult;
    kycStatusResult = KYCStatusResult;
    AOBStatus: string;
    craValid: boolean;
    profileStatus: string;
    amlReasons: string[];
    amlPepDetails: AmlPepDetails[];
    profileType: number;

    private profileId: number;
    private httpDetailsSubscription: Subscription;
    @InjectOptionDialog('reason-dialog') reasonDialog: OptionDialog;

    constructor(private _kycService: KycService,
                private _activatedRoute: ActivatedRoute,
                private _fileDownloadService: FileDownloadService,
                private _customerProfileService: CustomerProfileService) {
    }

    ngOnInit(): void {
        this._activatedRoute.parent.parent.params.subscribe(params => {
            this.loading = true;
            this.profileId = +params['id'];
            this.checkProfileState();
            this._kycService.getAOB(this.profileId).subscribe((response: string) => {
                let values = response.replace("; ;", ";").split(";");
                let cra = '';
                this.craValid = true;

                if (values.length === 0) {
                    this.craValid = false;
                }
                if (values.length === 3) {
                    cra = values[1];
                    this.craValid = false;
                }
                if (values.length === 2) {
                    this.craValid = true;
                }
                this.AOBStatus = "Documents: " + values[0] + ", CRA: " + cra + ", POA: " + values[values.length - 1];
                this.loading = false;
            });
        });
    }

    checkCRA(): boolean {
        return !this.craValid;
    }

    checkProfileState(): void {
        this._customerProfileService.searchCustomerProfileById(this.profileId)
            .subscribe((res: CustomerProfile) => {
                this.profileStatus = res.state;
                if (res.amlReasons && res.amlReasons.length > 0 && res.amlReasons[0] !== '') {
                    this.amlReasons = res.amlReasons;
                }
                this.amlPepDetails = res.amlPepDetails;
                this.profileType = res.type;
            });
    }

    isAOBVerified(): boolean {
        return this.AOBStatus != null;
    }

    hasAmlErrors(): boolean {
        return !isEmpty(this.amlReasons) || !isEmpty(this.amlPepDetails);
    }

    isPrivate(): boolean {
        switch (this.profileType) {
            case 1:
                return true;
            case 2:
                return false;
        }
    }

    onClickButton() {
        this.verifyClientProfile();
    }

    downloadCRAFile() {
        this._fileDownloadService.downloadCRAFile(this.profileId, 'CRA_' + this.profileId).subscribe((response: Response) => {
            FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
        });
    }

    downloadReport() {
        this._fileDownloadService.downloadNeocheckReport(this.profileId).subscribe((response: Response) => {
            FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
        });
    }

    kycApproved() {
        let kycApproval = (reason?: string) => {
            this._kycService.saveReason(this.profileId, reason)
            .subscribe(
                error => {
                    throw error;
                });
        };
        this.reasonDialog
        .showInputDialog({id: 'reason-dialog', title: 'TRANSFERS.DIALOG.REJECT'})
        .onConfirmAction((reason: string) => kycApproval(reason));
    }

    isUpdateButton(): boolean {
        return (this.profileStatusResult == this.kycStatusResult.AML_FOUND
            || this.profileStatusResult == this.kycStatusResult.CLEAR
            || this.profileStatusResult == this.kycStatusResult.INCOMPLETE_DATA);
    }

    isNotVerified() {
        return this.profileStatusResult == KYCStatusResult.NOT_VERIFIED;
    }

    private verifyClientProfile() {
        this.loading = true;
        this._kycService
        .verifyOrUpdateProfile(this.profileId)
        .subscribe(
            _ => this.fetchCompletedVerificationResults(),
            error => {
                throw error;
            });
    }

    private fetchVerificationResults() {
        this.loading = true;
        this.httpDetailsSubscription = Observable
        // Recheck verification progress each 7 seconds
        .interval(1000 * 7)
        // While result is on in progress
        .takeWhile(() => this.loading)
        .subscribe(_ => {
            this._kycService.getResult(this.profileId)
            .subscribe(results => {
                let isVerificationInProgress = KYCVerificationComponent.checkIsVerificationInProgress(results);

                if (!isVerificationInProgress) {
                    this.kycProfile = results;
                    this.loading = false;
                    this.profileStatusResult = results.summary_status.result;
                    return;
                }
            });
        });
    }

    private fetchCompletedVerificationResults() {
        this.loading = true;
        this.httpDetailsSubscription = Observable
        // Recheck verification progress each 7 seconds
        .interval(1000 * 7)
        // While result hasn't terminated state
        .takeWhile(() => this.loading)
        .subscribe(_ => {
            this._kycService.getResult(this.profileId)
            .subscribe(results => {
                let isVerificationComplete = KYCVerificationComponent.checkIsVerificationComplete(results);

                if (isVerificationComplete) {
                    this.kycProfile = results;
                    this.loading = false;
                    this.profileStatusResult = results.summary_status.result;
                    return;
                }
            });
        });
    }

    private static checkIsVerificationComplete(profile: KYCProfile): boolean {
        let summaryStatusResult = profile.summary_status.result;
        return summaryStatusResult.toString() !== KYCStatusResult.NOT_VERIFIED.toString() && summaryStatusResult.toString() !== KYCStatusResult.IN_PROGRESS.toString();
    }

    private static checkIsVerificationInProgress(profile: KYCProfile): boolean {
        let summaryStatusResult = profile.summary_status.result;
        return summaryStatusResult.toString() === KYCStatusResult.IN_PROGRESS.toString();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/kyc.verification.component.ts